<template>
  <div>
    <h1>Depositing to WSB</h1>
    <button class="btn-back" @click="backmenu">
      <img src="/icons/back.png" alt="Back" class="arrow-icon" />
      Back to Deposit Menu
    </button>
    <p>
      You can deposit money on your wallet. It’s Easy!<br>
      <img src="/icons/vodacom.png" alt="Vodacom Logo" style="height: 20px; vertical-align: middle; margin-right: 5px;">
      Vodacom M-Pesa Deposit.<br>
      Hello user: <a>{{ username }}</a>
    </p>

    <!-- Mostrar el contenedor solo si no se ha enviado el depósito -->
    <div v-if="showDepositForm" class="contenedor">
    <p>Please click on the amount you would like to deposit
      OR
      Please enter the amount in the box below</p>
     <!-- Botones de selección de cantidad -->
     <div class="amount-buttons">
        <button v-for="amt in amounts" :key="amt" :disabled="isLoading" @click="setAmount(amt)">
          {{ amt.toLocaleString() }} LSL
        </button>
      </div>
      
      <span>Amount</span>
      <div class="amount">
        <button class="button">LSL</button>
        <input type="number" v-model="amount" min="1" step="1" @input="validateAmount">
      </div>
      <div v-if="showError" class="mensaje-error">Min: 1 LSL</div>
      
      <div v-if="showPromoCode" class="promo-section">
        <div class="promo-label-container">
          <span class="promo-label">Promo Code</span>
          <span class="optional-badge">OPTIONAL</span>
        </div>
        <div class="promo-code">
          <input
            type="text"
            v-model="promoCode"
            placeholder="Enter your promo code here..."
            maxlength="50"
            :disabled="isLoading"
            @input="onPromoCodeInput"
            @blur="validatePromoCodeField"
          >
        </div>
        <div v-if="isValidatingPromo" class="promo-status loading">Validating promo code...</div>
        <div v-else-if="promoValidationMessage" class="promo-status" :class="promoValidationType">
          {{ promoValidationMessage }}
        </div>
        <div class="promo-attempts">
          Attempts left: {{ Math.max(0, maxPromoValidationAttempts - promoValidationAttempts) }}
        </div>
      </div>
      
      <!-- Mostrar el botón de depósito o el spinner si se está procesando -->
      <button class="deposit" @click="submitDeposit" :disabled="isDepositButtonDisabled">
        <span v-if="isLoading">Processing...</span>
        <span v-else style="color:black">Deposit</span>
      </button>
    </div>

    <!-- Mostrar el mensaje de éxito o error en la pantalla -->
    <div v-if="responseMessage" class="response-message" :class="responseType">
      <p v-html="responseMessage"></p>
    </div>

    <div class="finaltext">
      <p  v-if="responseMessage" >
        Your deposit should be on your account in a few seconds.
        If your deposit doesn't appear in your WSB balance in 5 seconds,<br>
        please <a  href="javascript:void(0)" @click="redirectContact">CLICK HERE</a> to contact us to let us know.
      </p>
      <p  v-else >
        After completing the above steps, your deposit will appear on your wsbetting.co.ls account.
        Please allow a few seconds for this to happen.<br>
        <a>Note</a>: Make sure any pop-up blocker is disabled.
      </p>
    </div>
  </div>
</template>

<script>
  import common from '@/scripts/common.js';

export default {
  data() {
    return {
      inmaintenance: false,
      username: this.$route.query.username || "Unknown User", // Obtener el parámetro de la URL
      amount: null,
      showPromoCode: false,
      promoCode: "",        // Campo para código promo
      promoValidationMessage: "",
      promoValidationType: "",
      isValidatingPromo: false,
      isPromoValid: null,
      promoValidationAttempts: 0,
      maxPromoValidationAttempts: 3,
      showError: false,
      responseMessage: "",  // Mensaje de la respuesta
      responseType: "",     // Tipo de mensaje (exito / error)
      showDepositForm: true, // Controla la visibilidad del formulario de depósito
      isLoading: false,      // Controla si la solicitud está en proceso
      amounts: [1,2,5, 10, 20, 30, 50, 100, 200, 300, 500, 700, 1000]
    };
  },
  computed: {
    hasPromoCodeInput() {
      return this.showPromoCode && (this.promoCode || "").trim().length > 0;
    },
    isDepositButtonDisabled() {
      if (this.isLoading || this.isValidatingPromo) {
        return true;
      }

      // Si hay promo code escrito, solo permitir depósito cuando esté validado.
      if (this.hasPromoCodeInput) {
        return this.isPromoValid !== true;
      }

      // Si el campo está en blanco, permitir flujo normal.
      return false;
    }
  },
  methods: {
    backmenu() {
      this.$router.push({ name: 'DepositWebsiteLesotho' , query: { username: this.$route.query.username }  });
    },
    redirectContact() {
      window.parent.postMessage({ action: 'btncontact' }, '*');
    },
    async loadConfig() {
      const promoCodeEnabled = await common.checkConfigLS("promo_code_website");
      this.showPromoCode = promoCodeEnabled === true;
      if (!this.showPromoCode) {
        this.promoCode = "";
      }
    },
    validateAmount() {
      this.showError = this.amount !== null && this.amount < 1;
    },
    onPromoCodeInput() {
      this.promoValidationMessage = "";
      this.promoValidationType = "";
      this.isPromoValid = null;
    },
    async validatePromoCodeField() {
      if (!this.showPromoCode) {
        return true;
      }

      const code = (this.promoCode || "").trim();
      if (!code) {
        this.promoValidationMessage = "";
        this.promoValidationType = "";
        this.isPromoValid = null;
        return true;
      }

      if (this.promoValidationAttempts >= this.maxPromoValidationAttempts && this.isPromoValid !== true) {
        this.promoValidationType = "error";
        this.promoValidationMessage = "You reached the maximum of 3 promo validation attempts.";
        return false;
      }

      try {
        this.isValidatingPromo = true;
        this.promoValidationMessage = "";
        this.promoValidationAttempts += 1;

        const apiUrl = process.env.VUE_APP_API_URL_GATEWAY;
        const response = await fetch(`${apiUrl}/wsb/system/validate-promo-code`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            player_id: this.username,
            code
          })
        });

        let result = {};
        try {
          result = await response.json();
        } catch (parseError) {
          result = {};
        }

        if (!response.ok) {
          const errorMsg = result.message || result.error || "Invalid promo code.";
          throw new Error(errorMsg);
        }
        //result.valid = true;
        const isValid = result.valid === true ||
          result.is_valid === true ||
          result.code === 0 ||
          result.code === "0" ||
          result.response_code === "INS-0" ||
          result.data?.response_code === "INS-0";

        if (!isValid) {
          const invalidMsg = result.message || result.response_desc || result.data?.response_desc || "Invalid promo code.";
          throw new Error(invalidMsg);
        }

        this.isPromoValid = true;
        this.promoValidationType = "success";
        this.promoValidationMessage = result.message || result.response_desc || result.data?.response_desc || "Promo code is valid.";
        return true;
      } catch (error) {
        this.isPromoValid = false;
        this.promoValidationType = "error";
        this.promoValidationMessage = error.message || "Invalid promo code.";
        return false;
      } finally {
        this.isValidatingPromo = false;
      }
    },
    async setAmount(value) {
      this.amount = value;
      this.showError = false;
       await this.submitDeposit();
    },
    async submitDeposit() {
      this.isLoading = true;  // Iniciar el estado de carga

      if (this.amount < 1) {
        this.responseMessage = "Amount must be at least 1 LSL.";
        this.responseType = "error";  // Tipo error
        this.isLoading = false;
        return;
      }

      if (this.showPromoCode && this.promoCode && this.isPromoValid !== true) {
        const promoIsValid = await this.validatePromoCodeField();
        if (!promoIsValid) {
          this.isLoading = false;
          return;
        }
      }

      const data = {
        username: this.username,
        amount: this.amount,
        promo_code: this.showPromoCode ? (this.promoCode || null) : null,
        origin: "iframewebsite"
      };

      try {
         const apiUrl = process.env.VUE_APP_API_URL_VODACOM;
        const response = await fetch(`${apiUrl}/api/deposit/create`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        });

        const result = await response.json();

        if (!response.ok) {
          throw new Error(result.message || "Unknown error occurred");
        }

        // Verificar si la respuesta fue exitosa basándonos en el código
        if (result.code === 0) {
          // Mostrar el mensaje general en la pantalla
          this.responseMessage = "<h2>"+result.data.response_desc+"</h2>";
          if (result.data.response_code === "INS-0")
            this.responseType = "success";  // Tipo éxito
          else
            this.responseType = "error";  // Tipo error

          // Si deseas mostrar el mensaje específico de Airtel
          this.responseMessage += "External Reference: " + result.data.conversation_id;
        } else {
          // Mostrar el mensaje de error si el código no es 0
          this.responseMessage = "Deposit failed: " + result.message;
          this.responseType = "error";  // Tipo error
        }
        
        // Ocultar el contenedor después de la respuesta
        this.showDepositForm = false;
        
      } catch (error) {
        console.error("Error submitting deposit:", error);
        this.responseMessage = error.message;
        this.responseType = "error";  // Tipo error
        this.showDepositForm = false; // Ocultar el contenedor en caso de error
      } finally {
        this.isLoading = false; // Finalizar el estado de carga
      }
    },
  
  sendHeight() {
        const height = document.body.scrollHeight;
        window.parent.postMessage({ iframeHeight: height }, "*");
      }
},

  async mounted() {
    await this.loadConfig();

    var maintenance = await common.checkMaintenanceLS("vodacom");
    
    if (maintenance) {
      this.$router.push({ name: 'DepositMaintenanceLesotho' , query: { username: this.$route.query.username }  });
    }

    // Enviar altura inicial al cargarse el componente
    this.sendHeight();

    // También puedes agregar un listener para resize si lo deseas
    window.addEventListener("resize", this.sendHeight);
  },

  updated() {
    // Enviar altura después de que el DOM se actualice (por si hay cambios dinámicos)
    this.$nextTick(() => {
      this.sendHeight();
    });
  },

  beforeUnmount() {
    // Limpiar el listener si lo agregaste
    window.removeEventListener("resize", this.sendHeight);
  }
};
</script>

<style scoped>
.arrow-icon {
  width: 16px;
  height: 16px;
  vertical-align: middle;
  margin-right: 8px;
}
.btn-back {
  background-color: #f99f44;        /* Naranja suave */
  color: rgb(0, 0, 0);
  padding: 8px 14px;
  border: none;
  border-radius: 6px;
  font-size: 0.8rem;
  /* font-weight: bold; */
  cursor: pointer;
  transition: background-color 0.3s ease;
  margin-bottom: 20px;
}

.btn-back:hover {
  background-color: #f67d3c;        /* Naranja más fuerte en hover */
}

.amount-buttons {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 10px 0;
}
.amount-buttons button {
  background-color: #ff8800;
  color: rgb(0, 0, 0);
  border: none;
  padding: 10px;
  margin: 5px;
  cursor: pointer;
  font-size: 14px;
  border-radius: 5px;
}
.amount-buttons button:hover {
  background-color: #cc6b00;
}

.amount-buttons button:disabled {
  background-color: #ffaa66; /* más claro y menos saturado */
  color: #5a5a5a;
  cursor: not-allowed;
  opacity: 0.8;
}

body {
  background-color: #f0f0f0;
  font-family: Arial, sans-serif;
}

h1 {
  /* color: #000000;
  text-align: center;
  font-weight: 800;
  background-color: #ff8800; */
   color: #000;
    text-align: center;
    font-weight: 800;
    /* background-color: #f80; */
    padding: 15px;
}

p {
  color: #555;
  text-align: center;
}

p strong{
  color: #000000;
}

.contenedor {
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 30px;
  padding-bottom: 30px;
  display: inherit;
  background-color: #e7e7e7;
  align-content: center;
  justify-items: center;
}

input[type="number"] {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 0px;
  font-size: 16px;
  width: 100%;
}

.button {
  padding: 10px 20px;
  background-color: #dedede;
  color: rgb(0, 0, 0);
  border: 1px solid #ccc;
  border-radius: 0px;
  font-size: 16px;
}

.mensaje-error {
  margin-top: 6px;
  /* margin-right: 430px; */
  font-size: 12px;
  color: #cc371b;
}

.deposit {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30%;
  min-width: 275px;
  margin-top: 10px;
  padding: 10px 20px;
  cursor: pointer;
  color: black;
  background-color: #cddc39;
   border: 2px solid #cddc39;
  border-radius: 6px ; /* Borde redondeado */
  transition: background-color 0.3s ease;
}

.deposit:hover {
  border: 2px solid #0e9e29;
  background-color: #b7dc39;
  /* border: none; */
}

.deposit:disabled {
  cursor: not-allowed;
  background-color: #ccc;
}

.finaltext {
  padding-left: 10px;
  padding-right: 10px;
  display: block;
}

.amount {
  width: 30%;
  min-width: 275px;
  display: flex;
  justify-content: center;
}

.promo-section {
  width: 30%;
  min-width: 275px;
  margin-top: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.promo-label-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-bottom: 8px;
  width: 100%;
}

.promo-label {
  color: #333;
  font-weight: 500;
  font-size: 14px;
}

.optional-badge {
  background-color: #ff8800;
  color: white;
  font-size: 11px;
  font-weight: bold;
  padding: 2px 8px;
  border-radius: 12px;
  letter-spacing: 0.5px;
}

.promo-code {
  width: 100%;
  display: flex;
  justify-content: center;
}

.promo-code input {
  padding: 12px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 6px;
  font-size: 15px;
  width: 100%;
  font-family: Arial, sans-serif;
  background-color: #fafafa;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.promo-code input:hover {
  border-color: #ff8800;
  background-color: #fff;
  box-shadow: 0 4px 8px rgba(255, 136, 0, 0.1);
}

.promo-code input:focus {
  outline: none;
  border-color: #ff8800;
  background-color: #fff;
  box-shadow: 0 4px 12px rgba(255, 136, 0, 0.15);
}

.promo-code input::placeholder {
  color: #aaa;
}

.promo-status {
  width: 100%;
  margin-top: 8px;
  font-size: 12px;
  text-align: left;
}

.promo-status.success {
  color: #1e7e34;
}

.promo-status.error {
  color: #c0392b;
}

.promo-status.loading {
  color: #8a6d3b;
}

.promo-attempts {
  width: 100%;
  margin-top: 6px;
  font-size: 11px;
  color: #666;
  text-align: left;
}

span {
  color: #505050;
  margin: auto;
}

/* Estilo para los mensajes de respuesta */
.response-message {
  margin-top: 20px;
  padding: 10px;
  text-align: center;
  border-radius: 5px;
  font-weight: bold;
}

.response-message.success {
  background-color: #d4edda;
  color: #155724;
}

.response-message.error {
  background-color: #f8d7da;
  color: #721c24;
}
</style>
